import React from "react";
import SectionShell from "./SectionShell";

export default function AdvantagesCards({ heading, subheading, cards }) {
  const list = Array.isArray(cards) ? cards : [];

  return (
    <div style={{ justifyContent:"center",display:'flex' }}>
      <SectionShell className="foundation-bubbles">
        {heading ? <div className="cl-h2">{heading}</div> : null}
        {subheading ? <p className="cl-body">{subheading}</p> : null}

        <div className="foundation-bubbles-grid">
          {list.map((c, i) => (
            <div className="foundation-card" key={`${c.title}-${i}`}>
              {c.image?.src ? (
                <img
                  className="foundation-card-image"
                  src={c.image.src}
                  alt={c.image.alt || ""}
                />
              ) : null}

              <div className="foundation-card-title cl-h2">
                {c.title}
              </div>

              {c.body ? (
                <p className="foundation-card-body cl-body">
                  {c.body}
                </p>
              ) : null}
            </div>
          ))}
        </div>
      </SectionShell>
    </div>
  );
}
